<template>
  <div class="home">

    <div id="header">
      <img class="AM-img inline-block" src='@/assets/AM.svg'/>
      <h1 id="title" class="inline-block">Tim sounds</h1>
      <img class="AM-img inline-block" src='@/assets/AM.svg'/>
    </div>

    <div class="images">
      <div id="sound1" class="divimage">
        <img class="image" v-bind:style="{ width:imageSize, height:imageSize }" src="@/assets/images/albatard.png" @click.prevent="playSound('albatard.mp3')"/>
        <p class="legend">Ah l'batard!</p>
      </div>
      <div id="sound2" class="divimage">
        <img class="image" v-bind:style="{ width:imageSize, height:imageSize }" src="@/assets/images/ahouais.png" @click.prevent="playSound('ahouais.mp3')"/>
        <p class="legend">Ah ouais ???</p>
      </div>
      <div id="sound3" class="divimage">
        <img class="image" v-bind:style="{ width:imageSize, height:imageSize }" src="@/assets/images/maisnan.png" @click.prevent="playSound('maisnan.mp3')"/>
        <p class="legend">Mais naaan!</p>
      </div>
    </div>
    <div class="images">
      <div id="sound4" class="divimage">
        <img class="image" v-bind:style="{ width:imageSize, height:imageSize }" src="@/assets/images/ahlenculs.png" @click.prevent="playSound('ahlenculs.mp3')"/>
        <p class="legend">Ah l'encul's!'</p>
      </div>
      <div id="sound5" class="divimage">
        <img class="image" v-bind:style="{ width:imageSize, height:imageSize }" src="@/assets/images/capartdela.png" @click.prevent="playSound('capartdela.mp3')"/>
        <p class="legend">Ca part de là!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      imageSizeAtt: window.innerWidth / 4
    }
  },
  computed: {
    imageSize: function () {
      return this.imageSizeAtt + 'px'
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    playSound (sound) {
      if (sound) {
        var soundUrl = require('../assets/sounds/' + sound)
        var audio = new Audio(soundUrl)
        audio.play()
      }
    },
    onResize (event) {
      this.imageSizeAtt = window.innerWidth / 4
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#header{
  text-align: center;
}
.inline-block{
  display: inline-block;
}
.AM-img{
  width: 5%
}
.images{
  padding:10px;
}
.divimage{
  width:30%;
  display:inline-block;
}
.legend{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue